var Default = {
  separator:
  /* "," */
  44,
  header:
  /* [] */
  0,
  has_header: true,
  strip: true,
  backslash_escape: false,
  excel_tricks: false,
  fix: false,
  quote_all: false
};
export { Default };
/* No side effect */